import { atom, atomFamily, selector } from 'recoil';
import { IActiveEmailClient, IClientEmailNavigate, IClientEmail } from './types';

export const ClientEmailNavigateState = atom<IClientEmailNavigate>({
	key: 'client-email-navigate-state-key',
	default: 'select-client',
});

export const ActiveEmailClientState = atom<IActiveEmailClient | null>({
	key: 'active-email-client-state-key',
	default: null,
});

export const ActiveEmailClientMethodState = atom<string>({
	key: 'active-email-client-method-state-key',
	default: '',
});

export const ActiveEmailClientFormDataState = atomFamily<
	{ [key: string]: string },
	string
>({
	key: 'active-email-client-form-data-state-key',
	default: {},
});

// New state for edit mode
export const EditModeState = atom<boolean>({
	key: 'edit-mode-state-key',
	default: false,
});

// New state to store the client being edited
export const EditingClientState = atom<IClientEmail | null>({
	key: 'editing-client-state-key',
	default: null,
});

// selector state for reset ActiveEmailClientFormDataState
export const ResetCredentialsState = selector({
	key: 'reset-creds-state-key',
	get: () => ({}),
	set: ({ set }, newValue) => {
		const newSet = set(ActiveEmailClientFormDataState(newValue as string), {});
		return newSet;
	},
});

export const EmailClientsState = atom<IClientEmail[]>({
	key: 'email-clients-state-key',
	default: [],
});

export const IsEmailClientsListLoadingState = atom<boolean>({
	key: 'is-email-clients-list-loading-state-key',
	default: false,
});

export const EmailClientActionLoadingState = atom<{[id: string]: boolean}>({
	key: 'email-client-action-loading-state-key',
	default: {},
});

export const ComplexEmailClientState = atom<string>({
	key: 'complex-email-client-state-key',
	default: '',
});